"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var R = _interopRequireWildcard(require("ramda"));
var _getWrap = _interopRequireDefault(require("./getWrap"));
var _getNodesHeight = _interopRequireDefault(require("./getNodesHeight"));
var _split2 = _interopRequireDefault(require("./split"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _createForOfIteratorHelperLoose(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (it) return (it = it.call(o)).next.bind(it); if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; } /* eslint-disable no-continue */ /* eslint-disable no-restricted-syntax */ // eslint-disable-next-line import/no-cycle
var getBreak = R.pathOr(false, ['props', 'break']);
var getBreakIfLastOnPage = R.pathOr(false, ['props', 'breakIfLastOnPage']);
var getMinPresenceAhead = R.path(['props', 'minPresenceAhead']);
var defaultPresenceAhead = function defaultPresenceAhead(element) {
  return function (height) {
    return Math.min(element.box.height, height);
  };
};
var getPresenceAhead = function getPresenceAhead(elements, height) {
  var result = 0;
  for (var i = 0; i < elements.length; i += 1) {
    var element = elements[i];
    if (!element.box) continue;
    var isElementInside = height > element.box.top;
    var presenceAhead = element.props.presenceAhead || defaultPresenceAhead(element);
    if (element && isElementInside) {
      result += presenceAhead(height - element.box.top);
    }
  }
  return result;
};

/**
 * Returns the height of the child components with `wrapTextAround` attribute if the parent node
 * has explicitly specified `hasWrapTextAroundComponent` attribute
 * @param {Object} node
 * @returns number
 */
var getWrapTextAroundChildrenHeight = function getWrapTextAroundChildrenHeight(node) {
  var _node$props;
  if (!((_node$props = node.props) !== null && _node$props !== void 0 && _node$props.hasWrapTextAroundComponent)) {
    return 0;
  }
  var queue = [node];
  var height = 0;
  while (queue.length) {
    var _top$props;
    var top = queue.pop();
    (top.children || []).forEach(function (child) {
      return queue.push(child);
    });
    if ((_top$props = top.props) !== null && _top$props !== void 0 && _top$props.wrapTextAround) {
      var _top$box;
      height += ((_top$box = top.box) === null || _top$box === void 0 ? void 0 : _top$box.height) || 0;
    }
  }
  return height;
};

/**
 * Returns whether the node or its children
 * has any drawable lines
 *
 * @param {Object} node
 * @returns boolean
 */
var hasAnyLines = function hasAnyLines(node) {
  var _node$lines;
  if (node !== null && node !== void 0 && (_node$lines = node.lines) !== null && _node$lines !== void 0 && _node$lines.length) {
    return true;
  }
  if (node !== null && node !== void 0 && node.children && Array.isArray(node.children)) {
    for (var _iterator = _createForOfIteratorHelperLoose(node.children), _step; !(_step = _iterator()).done;) {
      var child = _step.value;
      return hasAnyLines(child);
    }
  }
  return false;
};

/**
 * Returns whether the node can be drawn on the
 * current page
 *
 * @param {Object} node
 * @param {Number} presenceAhead
 * @param {Number} height
 * @param {Number} contentArea
 * @returns boolean
 */
var canDrawOnPage = function canDrawOnPage(node, presenceAhead, height, contentArea) {
  var nextHeight = (0, _getNodesHeight.default)([node]);
  if (nextHeight <= presenceAhead) return false;
  if (!(0, _getWrap.default)(node)) {
    return true;
  }
  var _split = (0, _split2.default)(node, height, contentArea),
    currentContent = _split[0];
  if (!hasAnyLines(currentContent)) return true;
  return false;
};
var shouldBreak = function shouldBreak(child, futureElements, height, contentArea) {
  var minPresenceAhead = getMinPresenceAhead(child);
  var presenceAhead = getPresenceAhead(futureElements, height);
  var futureHeight = (0, _getNodesHeight.default)(futureElements);
  var wrapTextAroundChildrenHeight = getWrapTextAroundChildrenHeight(child);
  var shouldSplit = height < child.box.top + child.box.height + wrapTextAroundChildrenHeight;
  var shouldWrap = (0, _getWrap.default)(child);
  return getBreak(child) || !shouldWrap && shouldSplit || wrapTextAroundChildrenHeight && shouldSplit || minPresenceAhead < futureHeight && presenceAhead < minPresenceAhead || getBreakIfLastOnPage(child) && futureElements.length && canDrawOnPage(futureElements[0], presenceAhead, height, contentArea);
};
var _default = exports.default = shouldBreak;